import { ActionTree } from 'vuex';
import { IAuthState, IRootStore, IUserState } from '../types';
import { api } from '@/services';

export const actions: ActionTree<IUserState, IRootStore> = {
};
